export const SECTION = 'email_quickrate'
